<template>
  <b-row class="asc__insertPage">
    <b-col cols="12">
      <header>
        <b-row>
          <b-col cols="12" md="6">
            <Breadcrumb />
          </b-col>
          <b-col cols="12" md="6" class="text-right">
            <router-link :to="{name: 'DiscountReason' }">
              <CancelButton />
            </router-link>
            <AddButton @click.native="save()" />
          </b-col>
        </b-row>
      </header>
    </b-col>
    <b-col cols="12" class="asc__insertPage-content-head">
      <section>
        <b-row>
          <NextFormGroup item-key="Code" :error="$v.form.Code">
            <NextInput type="text" v-model="form.Code" :disabled="insertReadonly.Code" />
          </NextFormGroup>
          <NextFormGroup item-key="Description1" :error="$v.form.Description1">
            <NextInput type="text" v-model="form.Description1" :disabled="insertReadonly.Description1" />
          </NextFormGroup>
          <NextFormGroup item-key="StatusId" :error="$v.form.StatusId">
            <NextCheckBox v-model="form.StatusId" type="number" toggle />
          </NextFormGroup>
        </b-row>
      </section>
    </b-col>
    <b-col cols="12">
      <b-tabs>
        <b-tab :title="$t('get.DiscountReason.General')" :active="!developmentMode">
          <b-row>
            <NextFormGroup item-key="DiscountClassId" :error="$v.form.DiscountClassId">
              <NextDropdown
                v-model="discountClass"
                @input="selectedSearchType('DiscountClassId', $event)"
                url="VisionNextDiscount/api/DiscountClass/Search"
              ></NextDropdown>
            </NextFormGroup>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>
<script>
import updateMixin from '../../mixins/update'
export default {
  mixins: [updateMixin],
  data () {
    return {
      form: {
        Deleted: 0,
        System: 0,
        RecordState: 2,
        StatusId: 1,
        Code: null,
        Description1: null,
        DiscountClassId: null
      },
      discountClass: null,
      routeName1: 'Discount'
    }
  },
  mounted () {
    this.getData().then(() => {
      this.setModel()
    })
  },
  methods: {
    setModel () {
      this.form = this.rowData
      this.discountClass = this.convertLookupValueToSearchValue(this.form.DiscountClass)
    },
    save () {
      this.$v.form.$touch()
      if (this.$v.form.$error) {
        this.$toasted.show(this.$t('insert.requiredFields'), {
          type: 'error',
          keepOnHover: true,
          duration: '3000'
        })
        this.tabValidation()
      } else {
        if (this.form.StatusId === 0) {
          this.form.StatusId = 2
        }
        this.updateData()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/DiscountReason/update.vue